<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <!--      <div>-->
      <!--        <el-input style="width: 300px;margin-right: 10px;" prefix-icon="el-icon-search"-->
      <!--                  v-model="reachCircle.title"-->
      <!--                  @keydown.enter.native="initCircles"-->
      <!--                  placeholder="请输入圈子名称进行搜索" clearable @clear="initCircles"></el-input>-->
      <!--        <el-button type="primary" icon="el-icon-search" @click="initCircles">搜索</el-button>-->
      <!--      </div>-->
      <!--      <div>
              <el-upload style="display: inline-flex;margin-right: 10px;"
                         :headers="headers"
                         :show-file-list="false"
                         :on-success="onSuccess"
                         :on-error="onError"
                         :disabled="importDataDisabled"
                         :before-upload="beforeUpload"
                         accept=".xls"
                         action="/api/user/import">
                <el-button type="success" :icon="importDataBtnIcon" :disabled="importDataDisabled">{{
                    importDataText
                  }}
                </el-button>
              </el-upload>
              <el-button type="success" icon="el-icon-download" @click="exportData">导出数据</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="showAddUserView">添加用户</el-button>
            </div>-->
    </div>
    <div style="margin-top: 30px;">
      <el-table
          v-loading="loading"
          :data="circles"
          border
          style="width: 100%">
        <!--        <el-table-column-->
        <!--            fixed-->
        <!--            type="selection"-->
        <!--            width="40">-->
        <!--        </el-table-column>-->
        <el-table-column
            label="申请人" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="getUserInfo(scope.row.userId)">{{ scope.row.nickname }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            label="头像" width="60">
          <template slot-scope="scope">
            <div class="demo-type">
              <div>
                <el-avatar :src="scope.row.icon" shape="square"></el-avatar>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="名称"
            width="200">
        </el-table-column>
        <el-table-column
            prop="introductory"
            label="简介"
            width="260">
        </el-table-column>
        <el-table-column
            prop="date"
            label="创建日期"
            width="200">
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="250">
          <template slot-scope="scope">
            <el-button type="success" v-if="scope.row.state===0" :loading="passLoading"
                       @click="showAuditCircle(scope.row.id)">通过
            </el-button>
            <el-button type="warning" v-if="scope.row.state===0" :loading="failLoading"
                       @click="auditFailed(scope.row.id)">
              驳回
            </el-button>
            <el-button type="danger" @click="deleteCircle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;display: flex;justify-content: space-between">
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="sizes,prev, pager, next, jumper, ->, total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%">
      <el-select v-model="circle.type">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="circle.remark" placeholder="备注" clearable style="padding-left: 10px;width: 45%;"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="auditPass">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        :visible.sync="userDialogVisible"
        width="50%" style="min-width: 350px">
      <div v-if="userInfoLoading">
        <el-descriptions :colon="false">
          <el-descriptions-item :colon="false">
            <el-avatar :size="70" :src="userInfo.avatarUrl"></el-avatar>
          </el-descriptions-item>
<!--          <el-descriptions-item label="用户名:">{{ userInfo.username }}</el-descriptions-item>-->
          <el-descriptions-item label="昵称:">{{ userInfo.nickname }}</el-descriptions-item>
          <el-descriptions-item label="学校:">
            <el-tag size="small">{{ userInfo.schoolName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="认证信息:">
            {{ userInfo.intro }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="userDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'CirclesList',
  data() {
    return {
      options: [{
        value: 0,
        label: '请选择圈子类型'
      }, {
        value: 1,
        label: '热门'
      }, {
        value: 2,
        label: '学习'
      }, {
        value: 3,
        label: '校园'
      }, {
        value: 4,
        label: '情感'
      }, {
        value: 5,
        label: '娱乐'
      }, {
        value: 6,
        label: '限定'
      }, {
        value: 7,
        label: '其他'
      }],
      circles: [],
      circle: {
        id: '',
        type: 0,
        remark: ''
      },
      loading: false,
      dialogVisible: false,
      userDialogVisible: false,
      userInfoLoading: false,
      total: 0,
      currentPage: 1,
      size: 10,
      passLoading: false,
      failLoading: false,
      userInfo: null,
      auditOption:'',
      info:{
        id:'',
        auditOption:''
      }
    }
  },
  mounted() {
    this.initCircles()
  },
  methods: {
    deleteCircle(circle) {
      this.$confirm('此操作将永久删除【' + circle.title + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/circles/web/' + circle.id).then(resp => {
          if (resp) {
            this.initCircles()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    showAuditCircle(data) {
      this.dialogVisible = true
      this.circle.id = data

    },
    sizeChange(size) {
      this.size = size
      this.initCircles()
    },
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.initCircles()
    },
    initCircles() {
      this.loading = true
      this.getRequest('/circles/web/auditList?currentPage=' + this.currentPage + '&size=' + this.size, this.reachCircle).then(resp => {
        this.loading = false
        if (resp) {
          this.circles = resp.data
          this.total = resp.total
        }
      })
    },
    getUserInfo(userId) {
      this.userDialogVisible = true
      this.postRequest('/circles/web/userInfo?id=' + userId).then(resp => {
        if (resp) {
          this.userInfo = resp
        }
        this.userInfoLoading = true
      })
    },
    auditPass() {
      this.$confirm('确定通过此圈子, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.circle.type === 0) {
          this.$message.error('请选择圈子类型')
          return
        }
        this.passLoading = true
        this.postRequest('/circles/web/auditPass/', this.circle).then(resp => {
          if (resp) {
            this.passLoading = false
            this.dialogVisible = false
            this.initCircles()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    auditFailed(id) {
      this.$prompt('请输入驳回原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // inputPattern: /^\s*$/,
        // inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        if (value === null) {
          this.$message.error('请输入驳回原因')
          return
        }
       // console.log("1111")
        this.submitAuditFailed(id, value)
        // this.$message({
        //   type: 'success',
        //   message: '你的邮箱是: ' + value
        // });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    submitAuditFailed(id, value) {
      this.info.id = id
      this.info.auditOption = value
      this.postRequest("/circles/web/failed", this.info).then(resp => {
        this.failLoading = false
        if (resp) {
          this.initCircles();
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
